import { render, staticRenderFns } from "./addOrModify.vue?vue&type=template&id=287ebdac"
import script from "./addOrModify.vue?vue&type=script&lang=ts"
export * from "./addOrModify.vue?vue&type=script&lang=ts"
import style0 from "./addOrModify.vue?vue&type=style&index=0&id=287ebdac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports